module.exports = __webpack_public_path__ + "static/media/changing-rooms.18012002.pdf";